import styled from 'styled-components'
import 'react-table/react-table.css'
import { P, SmallText } from 'konsys-ui'
import { theme, media } from '../../styles/_variables'

export const Wrapper = styled.div`
  overflow: auto;
`

export const HeaderCell = styled(P)`
  padding: 16px;
  color: #6F6E6E;
`

export const IdCell = styled(SmallText)`
  color: ${theme.color.primaryColor};
  text-decoration: underline;
`

export const TableDiv = styled.div`
  .ReactTable {
    border: none;
  }
  .ReactTable .rt-thead .rt-tr {
    display: flex;
  }
  .ReactTable .rt-thead .rt-th, .ReactTable .rt-thead .rt-td {
    padding: 0;
    border: none;
    color: ${theme.color.lightBlack} !important;
  }
  .ReactTable .rt-tbody .rt-td {
    border: none;
  }
  .ReactTable .rt-tbody .rt-tr-group {
    padding: 8px 0;
    border-bottom: 1px solid ${theme.color.paleGray} !important;
    display: flex;
  }
  .ReactTable .rt-thead.-header {
    box-shadow: none;
    border-top: 1px solid ${theme.color.paleGray} !important;
    border-bottom: 1px solid ${theme.color.paleGray} !important;
    background-color: ${theme.color.lightPaleGrey} !important;
  }
  .ReactTable .-pagination {
    box-shadow: none;
    border-top: none;
  }
`

export default Wrapper



// WEBPACK FOOTER //
// ./src/pages/history-page/styled.js